import { render, staticRenderFns } from "./AdminTemplate.vue?vue&type=template&id=34ef2d08&scoped=true&"
import script from "./AdminTemplate.vue?vue&type=script&lang=ts&"
export * from "./AdminTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AdminTemplate.vue?vue&type=style&index=0&id=34ef2d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef2d08",
  null
  
)

export default component.exports